import {
    FETCH_RAINPRO_LABELS,
    CLEAN_RAINPRO_LABELS,
    DOWNLOAD_RAINPRO_LABEL,
} from '../actions/types';
import _ from 'lodash';
import { toNumber } from '../functions';

const RAINPRO_LABELS_DEFAULT_STATE = {};

const RainproLabelsReducer = (state = RAINPRO_LABELS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_RAINPRO_LABELS:
            return payload;

        case DOWNLOAD_RAINPRO_LABEL:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload)) {
                    // Nasli sme stitok, zmenime status
                    item = { ...item, status: 'download' };
                }

                return item;
            }) };

        case CLEAN_RAINPRO_LABELS:
            return RAINPRO_LABELS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default RainproLabelsReducer;
